export const BASE_AFTERSALE = [
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    22,
    23,
    24,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    42,
    43,
    44,
    45,
    46,
    47,
    49,
    50,
    54,
    55,
    56
];

// 取消订单
export const CANCEL_ORDER = [1];

// 立即支付
export const PAY_NOW = [1];

// 申请退款
export const APPLY_REFUND = [2];

// 申请售后
export const AFTERSALE = BASE_AFTERSALE.concat(3, 101);

// 查看物流
export const CHECK_LOGISTICS = BASE_AFTERSALE.concat(3, 101);

// 确认收货
export const CONFIRM_RECIPET = [3];
